module.exports = __webpack_public_path__ + "img/salad.75352ce3.svg";